import { render, staticRenderFns } from "./RoleEditorView.vue?vue&type=template&id=cdeee09c&scoped=true&"
import script from "./RoleEditorView.vue?vue&type=script&lang=js&"
export * from "./RoleEditorView.vue?vue&type=script&lang=js&"
import style0 from "./RoleEditorView.vue?vue&type=style&index=0&id=cdeee09c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeee09c",
  null
  
)

export default component.exports